import { z } from 'zod';
import { ssEnvironments, ssApps } from '../aws-helpers.js';
export const nodeEnvironments = ['production', 'development'];
export const appBaseDomainName = 'signup.software';
const ALL_ENV_VARIABLES = z.object({
    // Global
    ENV: z.enum(ssEnvironments),
    NODE_ENV: z.enum(nodeEnvironments),
    TOP_LEVEL_DOMAIN: z.literal(appBaseDomainName),
    DOMAIN: z.string(),
    APP_NAME: z.enum(ssApps),
    SERVER_URL: z.string(),
    WEBSITE_URL: z.string(),
    AUTH_URL: z.string(),
    STORAGE_URL: z.string(),
    DATABASE_URL: z.string(),
    PORT: z.string().transform((port) => Number(port)),
    REDIS_URL: z.string(),
    GOOGLE_PLACES_API_KEY: z.string(),
    STRIPE_PUBLIC_KEY: z.string(),
    STRIPE_SECRET_KEY: z.string(),
    SENDGRID_KEY: z.string(),
    OPENAI_KEY: z.string(),
    SENTRY_DSN: z.string(),
    STRIPE_WEBHOOK_SECRET: z.string(),
    USER_POOL_ID: z.string(),
    USER_POOL_CLIENT_ID: z.string(),
    COMMIT_HASH: z.string(),
    USER_POOL_REGION: z.string(),
});
export const GLOBAL_APP_ENV = ALL_ENV_VARIABLES.pick({
    ENV: true,
    NODE_ENV: true,
    SENTRY_DSN: true,
    COMMIT_HASH: true,
    TOP_LEVEL_DOMAIN: true,
    APP_NAME: true,
});
export const COGNITO_DATA_ENV = ALL_ENV_VARIABLES.pick({
    USER_POOL_CLIENT_ID: true,
    USER_POOL_ID: true,
    USER_POOL_REGION: true,
});
export const PUBLIC_URLS_ENV = ALL_ENV_VARIABLES.pick({
    SERVER_URL: true,
    WEBSITE_URL: true,
    STORAGE_URL: true,
    AUTH_URL: true,
});
export const PUBLIC_KEYS_ENV = ALL_ENV_VARIABLES.pick({
    GOOGLE_PLACES_API_KEY: true,
    STRIPE_PUBLIC_KEY: true,
});
export const API_SECRETS_ENV = ALL_ENV_VARIABLES.pick({
    STRIPE_SECRET_KEY: true,
    SENDGRID_KEY: true,
    OPENAI_KEY: true,
    STRIPE_WEBHOOK_SECRET: true,
});
export const CONNECTION_STRINGS_ENV = ALL_ENV_VARIABLES.pick({
    DATABASE_URL: true,
    REDIS_URL: true,
});
export const CDK_APP_ENV = z
    .object({
    // These variables are injected into the .env file by our deployment script
    AWS_ACCOUNT_ID: z.string(),
    COMMIT_HASH: z.string(),
    AWS_REGION: z.string(),
})
    .required()
    .merge(GLOBAL_APP_ENV)
    .merge(PUBLIC_KEYS_ENV)
    .merge(API_SECRETS_ENV);
export const REMIX_CLIENT_ENV = GLOBAL_APP_ENV.merge(PUBLIC_KEYS_ENV)
    .merge(COGNITO_DATA_ENV)
    .merge(PUBLIC_URLS_ENV);
export const EXPRESS_SERVER_ENV = GLOBAL_APP_ENV.merge(API_SECRETS_ENV)
    .merge(CONNECTION_STRINGS_ENV)
    .merge(PUBLIC_URLS_ENV)
    .merge(COGNITO_DATA_ENV);
export const REMIX_SERVER_ENV = GLOBAL_APP_ENV.merge(PUBLIC_KEYS_ENV)
    .merge(API_SECRETS_ENV)
    .merge(COGNITO_DATA_ENV)
    .merge(PUBLIC_URLS_ENV)
    .merge(CONNECTION_STRINGS_ENV);
export const getPublicUrlsEnv = (domain) => ({
    SERVER_URL: `https://api.${domain}`,
    AUTH_URL: `https://auth.${domain}`,
    WEBSITE_URL: `https://${domain}`,
    STORAGE_URL: `https://storage.${domain}`,
});
//# sourceMappingURL=validate-environment.js.map